const wordBaronPriceLimit = 2.00;
const tokenSatAmount = 1000;

export { wordBaronPriceLimit, tokenSatAmount };